import React, { PureComponent } from "react";
import SubTopicWisePlatformAnalysisChart from "./SubTopicWisePlatformAnalysisChart";
import { Icon, Dropdown } from "semantic-ui-react";
import { connect } from "react-redux";
import html2canvas from "html2canvas";
import { downloadCSVData, downloadCanvasWithTitle, getViewConversationDuration } from "../utils";
import DimmerComponent from "../../DimmerComponent";
import moment from "moment-timezone";
import { ReactComponent as DownloadIcon } from "../../../../../assets/svg/downloads.svg";
import { ReactComponent as MoreOptions } from "../../../../../assets/svg/menu.svg";
import ChartOptionsSidebar from "../ChartsOptionsSidebar/ChartOptionsSidebar";
import DeleteWidget from "../ChartsOptionsSidebar/DeleteWidget";
import { ReactComponent as CloneIcon } from "../../../../../assets/svg/clone-icon.svg";
import { ReactComponent as Settings } from "../../../../../assets/svg/settings.svg";
import { showChartsDrilldown } from "../../../../../actions/dashboardAction";
import CustomCheckBox from "../ChartsOptionsSidebar/CustomCheckBox";
import NoData from "../NoData/NoData";
import IntervalSelector from "../IntervalSelector";
import { ChartFilterIcon } from "../ChartFilterOptions";
import ChartName from "../ChartName";
import { ReactComponent as MiniMize } from "../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import { ReactComponent as ComparisionIcon } from "../../../../../assets/svg/CompareChartIcon.svg";
import * as d3 from "d3";

class SubTopicWisePlatformAnalysis extends PureComponent {
    constructor(props) {
        super(props);
        this.selectedTopic = null;
        this.state = {
            downloading: false,
            aggs_val: "default",
        };
        this.chartEl = React.createRef();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.graph_type !== this.props.graph_type && this.props.graph_type === "line" && this.props.data && !this.props.data.hasLineData) {
            this.props.changeGraphType("line", true);
        }
    }
    addContextMenuListener = (x, y, chart) => {
        if (this.props.isPublic) return;
        let self = this;
        let contextMenu = d3.select(".dashboard-charts-contextmenu");
        contextMenu.attr("data-type", "clickedMenu");
        contextMenu.style("top", `${y + 10}px`);
        contextMenu.style("left", `${x + 10}px`);
        //  contextMenu.style("top", `${y + 10}px`);
        // contextMenu.style("left", `${x - 82}px`);
        contextMenu.style("background", `#fff`);
        contextMenu.style("color", `#1a1a1a`);
        contextMenu.html(null);
        contextMenu
            .append("li")
            .text("View Conversations")
            .on("click", () => {
                self.handleContextMenuClick(chart);
            });
        contextMenu
            .append("li")
            .text("View Insights")
            .on("click", () => {
                self.handleDrilldownClick(chart);
                this.props.showChartsDrilldown(true, "moments");
            });
        contextMenu.style("display", "block");
    };

    createNewFilter(chart) {
        let newFilter = this.props.filters ? JSON.parse(JSON.stringify(this.props.filters)) : {};
        newFilter.platforms = chart.platformId;
        newFilter.topics = chart.topicId || [];
        newFilter.subtopics = chart.subtopicId.flat() || [];
        return newFilter;
    }

    handleContextMenuClick(chart) {
        let newFilter = this.createNewFilter(chart);
        this.props.handleContextMenuClick(newFilter);
    }

    handleDrilldownClick(d) {
        let newFilter = this.createNewFilter(d);
        this.props.handleDrilldownClick(newFilter);
    }

    downloadTopicsOverallCSV = () => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        let csvFmt = [];
        let csvData = this.props.data.chartDataBar;
        let allTopics = this.props.data.chartDataBar[0].download_data;
        let allPlatforms = this.props.data.chartDataBar;
        let firstRow = ["Platform"];
        allTopics.forEach((ele, ind) => {
            firstRow.push(`${ele.name}`);
        });
        csvFmt.push(firstRow);
        csvData.forEach((ele, ind) => {
            let platformCount = [ele.name];
            ele.download_data.forEach((platform) => {
                platformCount.push(platform.y);
            });
            csvFmt.push(platformCount);
        });
        downloadCSVData(csvFmt, this.props.widget.name);
    };

    renderDownloadButton(nodata) {
        return (
            <Dropdown
                disabled={nodata}
                trigger={
                    <div className="chart-header-icon">
                        <DownloadIcon className="chart-download-icon" />
                    </div>
                }
                icon={null}
                className="chart-download-dropdown hideable"
                direction="left">
                <Dropdown.Menu>
                    <Dropdown.Item onClick={() => this.downloadTopicsOverallCSV()}>CSV</Dropdown.Item>
                    <Dropdown.Item onClick={() => this.downloadPNG(true)}>PNG</Dropdown.Item>
                    <Dropdown.Item onClick={() => this.downloadPNG(false)}>PNG(Transparent)</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        );
    }

    downloadPNG(options) {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        this.setState({ downloading: true });

        return html2canvas(this.chartEl.current, { backgroundColor: options ? "#fff" : null }).then((canvas) => {
            this.setState({ downloading: false });
            downloadCanvasWithTitle(canvas, this.props.widget.name);
        });
    }

    render() {
        let nodata = !this.props.data || (this.props.data && this.props.data.nodata) || this.props.noTopicsSelected;

        return (
            <>
                <div className="dashboard-widget-container-header skiptranslate">
                    <ChartName
                        name={this.props.widget.name}
                        info="This chart provides platform wise data count for the subtopics you have selected in the filters. The bars are arranged in descending order of subtopic wise mentions."
                    />
                    <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                        {this.props.graph_type !== "pie" &&
                            this.props.graph_type !== "bar" &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <Popup
                                    content="Chart Comparison Filters"
                                    position="bottom center"
                                    size="tiny"
                                    inverted
                                    className="skiptranslate"
                                    trigger={
                                        <div className={`chart-header-icon`} onClick={this.props.chartComparision}>
                                            <ComparisionIcon className={`comparision-filter${this.props.chartComparisionFilterApplied ? "-applied" : ""}`} />
                                        </div>
                                    }
                                />
                            )}
                        {!this.props.isPublic &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <ChartFilterIcon
                                    chartFilterApplied={this.props.chartFilterApplied}
                                    changeShowChartFilterOptions={this.props.changeChartFilter}
                                    widgetListDashboardCurrent={this.props.widgetListDashboardCurrent}
                                    name={this.props.widget.name}
                                />
                            )}
                        {!this.props.isPublic && !this.props.isResearchDashboard && <>{this.renderDownloadButton(nodata)}</>}
                        {
                            <>
                                {this.props.isPublic && nodata ? null : (
                                    <Popup
                                        className="skiptranslate"
                                        trigger={
                                            this.props.expandWidget ? (
                                                <MiniMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            ) : (
                                                <MaxiMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            )
                                        }
                                        inverted
                                        content={this.props.expandWidget ? "Minimize Widget" : "Maximize Widget"}
                                        size="mini"
                                        position="bottom center"
                                        style={{ zIndex: "99999" }}
                                    />
                                )}
                            </>
                        }
                        {this.props.isPublic && nodata ? null : <MoreOptions className="more-options" onClick={(e) => this.props.changeShowMoreOptions(e)} />}
                    </div>
                </div>
                {this.props.showMoreOptions && (
                    <ChartOptionsSidebar
                        data-html2canvas-ignore="true"
                        showMoreOptionsLoc={this.props.showMoreOptionsLoc}
                        changeShowMoreOptions={this.props.changeShowMoreOptions}>
                        {!nodata && this.props.graph_type !== "line" && (
                            <CustomCheckBox checked={this.props.hideLabel} onClick={this.props.changeHideLable} label="Show Labels" />
                        )}
                        {!nodata && <CustomCheckBox checked={this.props.showLegendBar} onClick={this.props.changeShowLegendBar} label="Show Legends" />}
                        {!nodata && (this.props.graph_type === "bar" || this.props.graph_type === "line") && (
                            <CustomCheckBox label="Show Grid Lines" checked={this.props.showGridLines} onClick={this.props.changeShowGridLines} />
                        )}
                        {!nodata && this.props.graph_type === "line" && (
                            <IntervalSelector
                                aggs_val={this.props.aggs_val}
                                appliedFilter={this.props.appliedFilter}
                                handleIntervalChange={this.props.handleIntervalChange}
                                disableComparisonInterval={this.props.disableComparisonInterval}
                            />
                        )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <>
                                    <div className="chart-settings menu-option" onClick={this.props.chartSettings}>
                                        <span>Chart Configuration</span>
                                        <Settings />
                                    </div>
                                    <div className="clone-chart menu-option" onClick={this.props.cloneWidget}>
                                        <span>Clone Chart</span>
                                        <CloneIcon />
                                    </div>
                                </>
                            )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && <DeleteWidget onClick={this.props.deleteWidget} />}
                    </ChartOptionsSidebar>
                )}
                {!nodata ? (
                    <div className="dashboard-chart skiptranslate" ref={this.chartEl}>
                        <SubTopicWisePlatformAnalysisChart
                            currentChartType={this.props.graph_type}
                            data={this.props.data}
                            addContextMenuListener={this.addContextMenuListener}
                            showLabel={this.props.hideLabel}
                            showLegend={this.props.showLegendBar}
                            showGridLines={this.props.showGridLines}
                            resizedCount={this.props.resizedCount}
                            comparisionData={this.props.comparisionData}
                            widgetContainerRef={this.props.widgetContainerRef}
                            expandWidget={this.props.expandWidget}
                        />
                        {this.state.downloading && <DimmerComponent />}
                    </div>
                ) : (
                    <NoData
                        message={
                            !this.props.isPublic && this.props.noTopicsSelected
                                ? "To view charts, please select topics using either the page filters on the left or the chart filters on this chart."
                                : null
                        }
                    />
                )}
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        allTopics: state.globalReducer.filterOptions ? state.globalReducer.filterOptions.topics : [],
        widgetListDashboardCurrent: state.dashboardReducer.widgetListDashboardCurrent,
        maximizeWidgetValue: state.dashboardReducer.maximizeWidgetValue,
    };
};

function mapDispatchToProps(dispatch) {
    return {
        showChartsDrilldown: (bool, name) => dispatch(showChartsDrilldown(bool, name)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SubTopicWisePlatformAnalysis);
